import { formatDate } from '@common';

type GetFilteredOptionsArgsType = {
  versions: string[];
  search: string;
};

export const getFilteredOptions = ({
  versions,
  search,
}: GetFilteredOptionsArgsType): string[] =>
  versions.filter((version) =>
    formatDate(version).includes(search.toLowerCase().trim())
  );
